import { JsonResult } from "@/script/core/base/JsonResult";
import { Failure, Success } from "@/script/core/service/DataService";
import { User } from "../entity/SystemEntity";
import store from "@/store";
import { BaseService } from "@/script/core/service/BaseService";

export interface LoginSuccess {
  (user: User): void;
}

export class UserService extends BaseService {
  public login(loginUser: User, success: LoginSuccess, failure: Failure) {
    super.postReturnResponse("/api/login", loginUser).then(
      function(response) {
        const token = response.headers.token;
        const resultJson = response.data as JsonResult;
        const user: User = resultJson.data as User;

        store.dispatch("changeLoginToken", token);
        store.dispatch("changeLoginUser", user);
        store.dispatch("changeLoginState", 1);

        // console.log(store.getters.loginToken);
        // console.log(store.getters.loginUserId);
        // console.log(store.getters.loginName);
        // console.log(store.getters.loginState);

        success(user);
      },
      function(error: Error) {
        failure(error);
      }
    );
  }

  public loadRoleList(success: Success, failure?: Failure) {
    super.get("/api/sys/user/role/list", { }).then(
      function(result) {
        success(result.data.list);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public changePassword(user: User, success: LoginSuccess, failure: Failure) {
    super.postReturnResponse("/api/sys/user/password/change", user).then(
      function(response) {        
        success(response);
      },
      function(error: Error) {
        failure(error);
      }
    );
  }  
}
